const hotjarId = process.env.REACT_APP_HOTJAR_ID;

const useHotjar = () => ({
  hotjarId,
});

export default useHotjar;
